import { Address } from 'viem'
import { BASE_URL } from './next.constants.mjs'

export const TOKENS = {
  MODUS: process.env.NEXT_PUBLIC_MODUS_TOKEN,
  STABLE_COIN: process.env.NEXT_PUBLIC_STABLE_COIN,
}

export const config = {
  BASE: {
    NAME: process.env.NEXT_PUBLIC_SITE_NAME,
    URL: BASE_URL,
  },
  CURRENCY: {
    CODE: process.env.NEXT_PUBLIC_CURRENCY || 'GBP',
    PRECISION: 2,
  },
  MARKETING: {
    FACBOOK_PIXEL_ID: process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID,
    FACEBOOK_CONVERSION_ID: process.env.NEXT_PUBLIC_FACEBOOK_CONVERSION_ID,
    GOOGLE_ANALYTICS_ID: process.env.NEXT_PUBLIC_GOOGLE_GA4_ID,
    KLAVIYO_ACCOUNT_ID: process.env.NEXT_PUBLIC_KLAVIYO_ID,
    KLAVIYO_API_KEY: process.env.KLAVIYO_API_KEY,
    TIKTOK_PIXEL_ID: process.env.NEXT_PUBLIC_TIKTOK_PIXEL_ID,
    X_PIXEL_ID: process.env.NEXT_PUBLIC_X_PIXEL_ID,
  },
  ADDRESS: {
    KYC: process.env.NEXT_PUBLIC_CONTRACT_KYC,
    ModusRegistry: process.env.NEXT_PUBLIC_CONTRACT_MODUS_REGISTRY,
    ModusStaking: process.env.NEXT_PUBLIC_CONTRACT_MODUS_STAKING,
    ModusToken: process.env.NEXT_PUBLIC_CONTRACT_MODUS_TOKEN,
    ModusProxyFactory: process.env.NEXT_PUBLIC_CONTRACT_MODUS_PROXY_FACTORY,
    PXRT: process.env.NEXT_PUBLIC_CONTRACT_PXRT,
    PXT: process.env.NEXT_PUBLIC_CONTRACT_PXT,
    PXTStaking: process.env.NEXT_PUBLIC_CONTRACT_PXT_STAKING,
    PriceModule: process.env.NEXT_PUBLIC_CONTRACT_PRICE_MODULE,
    StableCoinPXTSwap: process.env.NEXT_PUBLIC_CONTRACT_STABLE_COIN_PXT_SWAP,
    TokenModusSwap: process.env.NEXT_PUBLIC_CONTRACT_TOKEN_MODUS_SWAP,
    TokenStableCoinSwap:
      process.env.NEXT_PUBLIC_CONTRACT_TOKEN_STABLE_COIN_SWAP,
  } as Record<string, Address>,
  TOKENS: {
    MODUS: process.env.NEXT_PUBLIC_MODUS_TOKEN,
    STABLE_COIN: process.env.NEXT_PUBLIC_STABLE_COIN,
  } as Record<string, Address>,
}
